<template>
    <div v-loading="loading">
        <div class="top-title">
            <svg-icon icon-class="red-wallet" />
            <span class="text">钱包</span>
        </div>
        <div class="user-wallet">
            <div class="wallet">
                <div style="color: rgb(236, 33, 45);" class="text">{{ info.availableAmount | moneyFilter }}
                </div>
                <div style="color: rgb(236, 33, 45);" class="content">可用额度</div>
            </div>
            <!-- <div class="wallet">
            <div class="text">{{ info.mallBalance | moneyFilter }}</div>
            <div class="content">商城往来金额</div>
          </div>
          <div class="wallet">
            <div class="text">{{ info.rechargeBonus | moneyFilter }}</div>
            <div class="content">充值奖励金</div>
            <div id="cursor" class="content" @click="dilongShow"><img style="width:20px;height:20px;vertical-align: sub;" src="../../../assets/images/toSee.png" alt="">查看明细</div>
          </div> -->
            <div class="wallet">
                <div class="text">
                    {{ info.accountPeriod | monthFilter }}
                    <el-popover placement="top" width="200" trigger="hover">
                        <div>
                            结账日：{{ info.fSettleAccountsDay | changeNumToHan }}
                        </div>
                        <div>
                            对账日：{{ info.fReconciliationDay | changeNumToHan }}
                        </div>
                        <div>
                            开票日：{{ info.fBillingDay | changeNumToHan }}
                        </div>
                        <div>
                            付款日：{{ info.fPaymentDay | changeNumToHan }}
                        </div>
                        <i slot="reference" style="color:#ec212d;" class="el-icon-warning-outline" />
                    </el-popover>
                </div>
                <div class="content">账期</div>
            </div>
            <div class="wallet">
                <div class="text">￥{{ (info.mallBalance * -1) | moneyFilter }}</div>
                <div class="content">当前待还款金额</div>
            </div>
        
        </div>
    </div>
</template>

<script>


import quest from '../api/user'
export default {
    filters: {
        // 数字转汉字
        changeNumToHan(num) {
            if (num === '') return ''
            var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
            var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
            if (!num || isNaN(num)) return '零'
            var english = num.toString().split('')
            var result = ''
            for (var i = 0; i < english.length; i++) {
                var des_i = english.length - 1 - i // 倒序排列设值
                result = arr2[i] + result
                var arr1_index = english[des_i]
                result = arr1[arr1_index] + result
            }
            result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十') // 将【零千、零百】换成【零】 【十零】换成【十】
            result = result.replace(/零+/g, '零') // 合并中间多个零为一个零
            result = result.replace(/零亿/g, '亿').replace(/零万/g, '万') // 将【零亿】换成【亿】【零万】换成【万】
            result = result.replace(/亿万/g, '亿') // 将【亿万】换成【亿】
            result = result.replace(/零+$/, '') // 移除末尾的零
            // 将【一十】换成【十】
            result = result.replace(/^一十/g, '十')
            return `每月${result}号`
        },
        // 金额字符处理
        moneyFilter(val) {
            if (!isNaN(Number(val))) {
                const num = Number(val).toFixed(3)
                const index = num.indexOf('.')
                const str = num.slice(index, index + 3)
                const dnum = num.slice(0, index)
                let length = dnum.length
                let lengthnum = 0
                let newstr = ''
                do {
                    let dou = ''
                    if (lengthnum % 3 == 0) {
                        dou = ','
                    }
                    length--
                    lengthnum++
                    newstr += dou + dnum[length]
                } while (length)
                if (newstr[0] === ',') {
                    newstr = newstr.slice(1)
                }
                let mony = newstr
                    .split('')
                    .reverse()
                    .join('') + str
                if (mony.indexOf('-,') > -1) {
                    mony = mony.replace(',', '')
                }
                return (
                    mony
                )
            }
        },
        // 金额月份处理
        monthFilter(num) {
            if (!isNaN(Number(num))) {
                num = Math.ceil(Number(num) / 30)
                var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
                var arr2 = [
                    '',
                    '十',
                    '百',
                    '千',
                    '万',
                    '十',
                    '百',
                    '千',
                    '亿',
                    '十',
                    '百',
                    '千',
                    '万',
                    '十',
                    '百',
                    '千',
                    '亿'
                ]
                if (!num || isNaN(num)) return '零'
                var english = num.toString().split('')
                var result = ''
                for (var i = 0; i < english.length; i++) {
                    var des_i = english.length - 1 - i
                    // 倒序排列设值
                    result = arr2[i] + result
                    var arr1_index = english[des_i]
                    result = arr1[arr1_index] + result
                }
                result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十')
                // 将【零千、零百】换成【零】 【十零】换成【十】
                result = result.replace(/零+/g, '零')
                // 合并中间多个零为一个零
                result = result.replace(/零亿/g, '亿').replace(/零万/g, '万')
                // 将【零亿】换成【亿】【零万】换成【万】
                result = result.replace(/亿万/g, '亿')
                // 将【亿万】换成【亿】
                result = result.replace(/零+$/, '')
                // 移除末尾的零 // 将【一十】换成【十】
                result = result.replace(/^一十/g, '十')
                return result + '个月'
            }
        }
    },
    data() {
        return {
            loading:false,
            info: {
                availableFund: 0,
                totalCredit: 0,
                accountPeriod: 0,
                cashBalance: 0,
                cashCoupon: 0,
                stockCollect: 0,
                storeCollect: 0,
                browseRecords: 0,
                fSettleAccountsDay: '',
                fReconciliationDay: '',
                fBillingDay: '',
                fPaymentDay: ''
            },
        }
    },
    mounted() {
        this.initUser()
    },
    methods: {
        initUser() {
            this.loading=true;
            quest.userInfo().then(res => {
                this.loading=false;
                if (res.result) {
                    this.info = res.data
                    // this.StockCollectTotal = this.info.stockCollect || 0
                    // this.StoreCollectTotal = this.info.storeCollect || 0
                    // this.BrowseRecordsTotal = this.info.browseRecords || 0
                }
            })
        },
    }
}
</script>

<style lang="scss">
.user-wallet {
    // margin-bottom: 35px;
    display: flex;
    margin-top: 10px;
    flex-wrap: wrap;

    .wallet {
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;
        min-width: 306px;
        height: 135px;
        //   flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #fff;

        .text {
            font-size: 24px;
            font-family: DIN;
            font-weight: 600;
            color: #333333;
        }

        .content {
            font-size: 14px;
            font-family: SimSun;
            font-weight: 400;
            color: #333333;
            margin-top: 20px;
        }

        #cursor {
            position: absolute;
            bottom: -26px;
            color: rgb(236, 33, 45);
            cursor: pointer;
        }
    }
}

.top-title {
    height: 64px;
    line-height: 64px;
    padding-left: 20px;
    background: #fff;

    .red-wallet {
        vertical-align: baseline;
    }

    .text {
        font-size: 16px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #000000;
        padding-left: 12px;
    }
}
</style>